import { Heart } from 'lucide-react'
import { useDonsModal } from '@/hooks/useDonsModal'

export default function DonsSection() {
  const { open } = useDonsModal()

  return (
    <section id="dons" className="py-16 md:py-20 px-4 bg-white">
      <div className="max-w-lg md:max-w-3xl mx-auto text-center md:text-left md:flex md:items-center md:gap-6">
        <div className="w-12 h-12 bg-cmp-sky-light rounded-full flex items-center justify-center mx-auto md:mx-0 mb-4 md:mb-0 shrink-0 shadow-[0_2px_10px_rgba(15,31,92,0.06)] ring-1 ring-cmp-gold-light/30">
          <Heart size={20} className="text-cmp-gold" />
        </div>
        <div className="md:flex-1">
          <h2 className="text-xl font-bold text-cmp-navy mb-2">Soutenir l'église</h2>
          <p className="text-gray-500 text-sm leading-relaxed max-w-xs md:max-w-none mx-auto md:mx-0">
            Vos dons financent le ministère et étendent la mission. Donnez facilement par Orange Money, Airtel Money ou M-Pesa.
          </p>
        </div>
        <button
          type="button"
          onClick={open}
          className="mt-6 md:mt-0 inline-flex items-center gap-2 bg-cmp-blue text-white font-bold rounded-full py-3.5 px-8 text-sm shadow-md shadow-cmp-blue/20 hover:bg-cmp-blue-light transition-colors active:scale-95 shrink-0"
        >
          Donner maintenant
        </button>
      </div>
    </section>
  )
}
